import styled, { css } from "styled-components"
import { desktopTextStyles, FontFamilyRegular } from "../typography.styles"
import Breakpoints from "../breakpoints"

export const FormContainer = styled.div``

export const FormGrid = styled.form`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 24px;

  @media (min-width: ${Breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }
`

export const FormSubmitButton = styled.button`
  display: flex;
  justify-content: center;
  ${FontFamilyRegular}
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  background-color: var(--burnt-orange);
  color: var(--white);
  padding: 16px 32px;

  border: none;
  outline: none;
  justify-self: center;
  align-self: center;
  cursor: pointer;
  user-select: none;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: span 2;
  }

  ${props =>
    props.disabled &&
    css`
      background-color: #8c6053;
      color: var(--dark-mode-heading);
      cursor: initial;
    `}
`

export const ValidationContainer = styled.div`
  min-height: 78px;
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  max-width: 100%;

  //stop captcha from causing stuff to overflow
  position: relative;
  & > * {
    position: absolute;
  }
`

const MessageBlock = styled.div`
  display: inline-flex;
  grid-column: 1 / -1;
  justify-self: center;
  align-items: center;

  padding: 24px 32px;
  margin-bottom: 32px;

  & > img:first-child {
    margin-right: 16px;
  }

  ${FontFamilyRegular}
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 170%;

  color: #2e2e2e;

  a,
  a:link,
  a:visited,
  a:active {
    color: var(--burnt-orange);
    text-decoration: none;
  }
`

export const SuccessBlock = styled(MessageBlock)`
  background: #f6faf7;
  border: 1px solid #4f9866;
  box-sizing: border-box;
  border-radius: 2px;
`
export const ErrorBlock = styled(MessageBlock)`
  background: #fcf4f4;
  border: 1px solid #ca3232;
  box-sizing: border-box;
  border-radius: 2px;
`
